import { TestStep } from '@testsigma/organism';
import { Base } from 'models/base.model';
import {
  custom,
  deserialize,
  list,
  object,
  optional,
  serializable,
} from 'serializr';

export class TestCaseCreateRequest extends Base {
  @serializable
  public applicationVersionId: number;

  @serializable
  public isStepGroup: boolean;

  @serializable
  public scenarioId: string;

  @serializable
  public name: string;
}

export class TestCaseAlphaCreateRequest extends Base {
  @serializable
  public applicationVersionId: number;

  @serializable
  public name: string;

  @serializable
  public description: string;

  @serializable(optional(list(object(TestStep))))
  public testSteps: TestStep[];

  @serializable(optional())
  public aiDescription: string;

  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public aiEntities: any[];

  @serializable
  public feature: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(TestCaseAlphaCreateRequest, input));
  }
}

export class TestCaseBulkAlphaCreateRequest extends Base {
  @serializable(optional(list(object(TestCaseAlphaCreateRequest))))
  public testCases: TestCaseAlphaCreateRequest[];

  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public aiEntities: any[];

  @serializable
  public feature: string;

  deserialize(input: any): this {
    return Object.assign(
      this,
      deserialize(TestCaseBulkAlphaCreateRequest, input),
    );
  }
}
